import { NgModule } from '@angular/core';
import { LibSaveIconPinkComponent } from './lib-save-icon-pink.component';

@NgModule({
  declarations: [LibSaveIconPinkComponent],
  imports: [],
  exports: [LibSaveIconPinkComponent],
})
export class LibSaveIconPinkModule {}
